window.PasVariantState = window.PasVariantState || {
  byId(variants, id) {
    return variants.find((variant) => String(variant.id) === String(id)) || null;
  },
  resolve(variants, active, optionIndex, value) {
    if (!active) return null;
    const desired = [...active.options];
    desired[optionIndex] = value;
    return variants.find((variant) => variant.options.every((option, index) => option === desired[index])) || null;
  },
};
